import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as InspectionActions from '../../inspection/inspection.actions';
import { getAllAvailableTypesForList, getInspectionsForBrandType } from '../../inspectionType/inspectionType.selectors';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  paper: {
    maxWidth: 1040,
    margin: '0 auto',
  },
  value: {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.83)',
    marginBottom: '1.5rem',
  },
  wrapper: {
    marginTop: theme.spacing.unit * 2,
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  buttonSubed: {
    color: 'rgba(1, 0, 0, 0.83)',
    fontSize: '46px',
  },
  button: {
    '@media (max-width:520px)': {
      textAlign: 'left',
    },
  },
});

const propTypes = {
  subscribedReports: PropTypes.array.isRequired,
  inspectionTypes: PropTypes.array.isRequired,
  inspections: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  subscribedReports: [], // 'brand.type.model
  inspectionTypes: [],
  inspections: [],
  onChange: null,
};

class ReportSubscriptions extends Component {
  componentDidMount = () => {
    const { readInspectionTypes } = this.props;
    readInspectionTypes();
  };

  onSubscriptionClick = (brandId, typeId) => {
    const { subscribedReports } = this.props;
    //console.log(subscribedReports);
    const selectedsubscription = brandId + '.' + typeId;
    if (subscribedReports.indexOf(selectedsubscription) > -1) {
      //console.log("You REMOVED sub for:\n",selectedsubscription);
      this.removeSubscription(subscribedReports.indexOf(selectedsubscription));
    } else {
      //console.log("You ADDED sub for:\n",selectedsubscription);
      this.addSubscription(selectedsubscription);
    }
  };

  addSubscription = value => {
    const { subscribedReports, onChange } = this.props;
    let reports = subscribedReports.slice();
    if (value !== '') {
      reports.push(value);
    }
    onChange(reports);
  };

  removeSubscription = index => {
    const { subscribedReports, onChange } = this.props;
    let reports = subscribedReports.slice();
    reports.splice(index, 1);
    onChange(reports);
  };

  render() {
    const { inspectionTypes, subscribedReports, classes } = this.props;

    return (
      <div className={classes.wrapper}>
        <Typography type="caption" gutterBottom>
          Sähköpostimuistutukset raporteista
        </Typography>

        <div>
          {inspectionTypes.map((inspection, i) => {
            return (
              <div className={classes.wrapper} key={i}>
                {subscribedReports.indexOf(inspection.brandId + '.' + inspection.typeId) > -1 ? (
                  <Button
                    className={classes.button}
                    tabIndex={i}
                    style={{ color: 'green' }}
                    onClick={() => {
                      this.onSubscriptionClick(inspection.brandId, inspection.typeId);
                    }}
                  >
                    {inspection.label + ' - SEURANNASSA'}
                  </Button>
                ) : (
                  <Button
                    className={classes.button}
                    onClick={() => {
                      this.onSubscriptionClick(inspection.brandId, inspection.typeId);
                    }}
                  >
                    {inspection.label}
                  </Button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

ReportSubscriptions.propTypes = propTypes;
ReportSubscriptions.defaultProps = defaultProps;

const mapStateToProps = (state, { match }) => {
  let inspectionTypes = getAllAvailableTypesForList(state) || [];
  inspectionTypes.forEach(inspectionType => {
    inspectionType.inspections = getInspectionsForBrandType(state, inspectionType.brandId, inspectionType.typeId);
  });

  return {
    inspectionTypes,
  };
};

const ConnectedReportSubscriptions = connect(mapStateToProps, Object.assign({}, InspectionActions))(
  ReportSubscriptions
);
export default withStyles(styles)(ConnectedReportSubscriptions);



// WEBPACK FOOTER //
// ./src/modules/user/components/ReportSubscriptions.js